// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"79":"polyfill-element-closest","114":"polyfill-mutation-observer","557":"polyfill-fetch","781":"polyfill-custom-event","784":"polyfill-dataset","787":"polyfill-intersection-observer"}[chunkId] + "." + chunkId + ".js";
};